import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { urlParams } from 'utils/request';
import useStarfishAPI from '../hooks/useStarfishAPI';
import useError from '../hooks/useError';
import css from './ServiceSelection.css';
import { Card } from 'semantic-ui-react';
import { camelCase } from 'lodash';
import ServicesCardTopBar from "../serviceCatalog/home/services/ServicesCardTopBar";
import { getServicePhotoUrl } from "../utils/images";

function ServiceSelection(props) {
  // Declarative callbacks for the starfish API

  props.setWarning(null);

  const [{ data, success, error }, callAPI] = useStarfishAPI();

  const getServices = () => {
    // SD-9362 was created to consider adjusting the backend to use UUID's here instead of partyId
    const params = urlParams({ kioskId: props.kioskId, studentId: props.studentId, isProspectiveStudent: props.isProspectiveStudent}, false);
    const URL = `../kiosk/getServicesForKiosk.html?${params}`;
    callAPI(URL, {
      method: 'GET',
    });
  };

  // Listen to error and call props.setError whenever there is a change
  useError(error, props.setError);

  // Fetch services on first mount and whenever params change
  useEffect(() => {
    getServices();
  }, [props.kioskId, props.studentId, props.isProspectiveStudent]);

  if (!success) return <div>Loading services...</div>;
  if (!data.services || data.services.length < 1) {
    // This shouldn't happen since the sign in checks for available services, but just for edge cases...
    props.startOver();
    props.setError("There was an error retrieving available services, please try signing in again.");
    return null;
  }

  if (data.services.length === 1 ) {
    // Replace history if there are no other services the user could have an appointment or checked in.
    // Otherwise, route the student properly.
    props.selectService(data.services[0], true);
    return null;
  }
  const displayName = service => service.courseDisplayName ? service.courseDisplayName : service.name

  return (
      <div className={css["content"]}>
        <h1 className={css["h1"]}>{`Hi, ${props.studentName}!`}</h1>
        <h1 className={css["h1"]}>{props.greetingText}</h1>
        <h2 className={css["h2"]}>{props.mainHeader}</h2>
        <div className={css["cards-container"]}>
          {data.services.map((service) =>
            <div key={service.serviceId} className={css["card-container"]}>
              <Card
                fluid 
                id={camelCase(`serviceCard ${displayName(service)}`)}
                className={css["card"]}
                onClick={() => props.selectService(service)}
                tabIndex="0"
                aria-label={displayName(service)}
                role="button"
              >
                <ServicesCardTopBar serviceUuid={service.serviceUid} />
                <Card.Content className={css['card-content']}>
                  <div className={css["card-title"]}>{displayName(service)}</div>
                  <div className={css["card-image"]} style={{backgroundImage: `url(${getServicePhotoUrl(service.serviceUid)})`}} />
                </Card.Content>
              </Card>
            </div>
          )}
        </div>
      </div>
  );
}

ServiceSelection.propTypes = {
  kioskId: PropTypes.number.isRequired,
  setError: PropTypes.func.isRequired,
  studentName: PropTypes.string.isRequired,
  studentId: PropTypes.number,
  isProspectiveStudent: PropTypes.bool.isRequired,
  selectService: PropTypes.func.isRequired,
  startOver: PropTypes.func.isRequired,
  setWarning: PropTypes.func.isRequired,
  greetingText: PropTypes.string,
  mainHeader: PropTypes.string,
  otherKioskServices: PropTypes.arrayOf(Object)
};

export default ServiceSelection;
